import React from 'react';

export default function OutletMaintenance() {
  return <div>OutletMaintenance</div>;
}
